module.exports = __webpack_public_path__ + "img/check-circle.9aa71d77.svg";